import { FunctionComponent, useLayoutEffect } from 'react'
import { Box, IconButton, Typography, Link } from '@material-ui/core'
import { ExitToAppOutlined, Person } from '@material-ui/icons'

//@ts-ignore
import { useTheme } from 'styled-components'
import styled from 'styled-components/macro'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { Logo } from 'components/page/logo'
import { AdminProfile } from './AdminProfile'
import { AdminSideNav } from './AdminSideNav'
import { AdminDropDown } from './AdminDropDown'
import { Footer } from 'components/page/footer'
import { ReactComponent as SunIcon } from 'icons/sun.svg'
import { ReactComponent as MoonIcon } from 'icons/moon.svg'
import { useUpdateModePreference } from 'hooks/use-update-mode-preference/useUpdateModePreference'
import { useThemeSwitch } from 'hooks/theme'

const StyledIconButton = styled(IconButton)`
  && {
    margin: 0 0 0 -0.5em;
    height: 20px;
    align-self: center;
  }
`
const StyledExitButton = styled(ExitToAppOutlined)`
  && {
    font-size: 1em;
    fill: ${props => props.theme.colors.accent1};
  }
`
const StyledUserButton = styled(Person)`
  && {
    font-size: 1em;
    fill: ${props => props.theme.colors.accent1};
  }
`

const StyledMoonIcon = styled(MoonIcon)`
  && {
    height: 17px;
    width: 17px;
  }
`
const StyledSunIcon = styled(SunIcon)`
  && {
    height: 17px;
    width: 17px;
  }
`
interface AdminContainerProps {
  title: string
  shrinkLogo?: boolean
  stickTopBar?: boolean
  nopadding?: boolean
  showSearch?: boolean
  inviteUsersByEmail?: Function
}

export const AdminContainer: FunctionComponent<AdminContainerProps> = ({
  title,
  children,
  shrinkLogo,
  nopadding
}) => {
  const theme = useTheme()
  const { onLogout, backendUser } = useAuth()
  const { handleModeChange } = useUpdateModePreference()
  const { mode } = useThemeSwitch()
  const { isDevice } = useScreenSizes()
  const { pathname } = useLocation()


  useLayoutEffect(() => {
    document.title = `${title} | Admin Dashboard`
  }, [title])

  const navbarPadding = () => {
    if ((nopadding && isDevice) || isDevice) {
      return '0 1em'
    }
    return '0'
  }

  return (
    <>
      <Box display="flex">
        <Box
          bgcolor={theme.colors.supplementary}
          p={navbarPadding()}
          display="flex"
          justifyContent="center"
          top="0"
          zIndex="3"
          boxShadow={theme.colors.shadowXSmall}
          width="100%"
          position='fixed'
        >
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            margin="auto"
            height="4.335em"
            width="100%"
            marginLeft="7em"
          >
            <Box display="flex" alignSelf="center" position="relative" justifyContent="center">
              <Logo pathname={pathname} bright size={shrinkLogo ? 'x-small' : 'small'} />
            </Box>

            <Box display="flex" alignItems="center" marginRight="2em">
              <AdminDropDown title="" icon={<AdminProfile avatar={backendUser?.image} name={backendUser?.firstName} />}>
                <StyledIconButton size="small">
                  <Box display="flex" flexDirection="row">
                    <StyledUserButton />
                    <Typography variant="caption" component="span">
                      <Link component={RouterLink} to="/profile" style={{ textDecoration: 'none' }}>
                        <Box color={theme.colors.accent1} m="0 1em">
                          My Page
                        </Box>
                      </Link>
                    </Typography>
                  </Box>
                </StyledIconButton>

                <StyledIconButton
                  size="small"
                  onClick={() => {
                    handleModeChange()
                  }}
                >
                  <Box m=".2em" display="flex" flexDirection="row">
                    {mode === 'dark' ? <StyledMoonIcon /> : <StyledSunIcon />}
                    <Typography variant="caption" component="span">
                      <Box color={theme.colors.accent1} m="0 1em">
                        Mode
                      </Box>
                    </Typography>
                  </Box>
                </StyledIconButton>

                <Box bgcolor={theme.colors.supplementary} width="100%" height="0.1em"></Box>
                <StyledIconButton size="small" onClick={() => onLogout()}>
                  <Box display="flex" flexDirection="row">
                    <StyledExitButton />
                    <Typography variant="caption" component="span">
                      <Box color={theme.colors.accent1} m="0 1em">
                        Logout
                      </Box>
                    </Typography>
                  </Box>
                </StyledIconButton>
              </AdminDropDown>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box height="inherit" position="fixed">
        <AdminSideNav />
      </Box>
      <Box marginLeft='20em' marginTop='5em' marginBottom='6em'>{children}</Box>
      <Box position='fixed' bottom="0em" width="100%">
        <Footer admin />
      </Box>
    </>
  )
}
